import { Component } from '@angular/core';

@Component({
  selector: 'app-derivaciones',
  templateUrl: './derivaciones.component.html',
  styleUrl: './derivaciones.component.css'
})
export class DerivacionesComponent {

}
